export default "__VITE_ASSET__BrQ9l4zc__"